import { vcsAppAuthorizeUrl, stage } from 'constants/config';
import type { GitProviderTypes } from 'types/api.types';

type GenerateVcsRedirectLinkParams = {
  gitProvider: GitProviderTypes;
  organizationId: string;
  accessToken: string;
};

export const generateVcsRedirectLink = ({
  gitProvider,
  organizationId,
  accessToken
}: GenerateVcsRedirectLinkParams) => {
  const url = new URL(vcsAppAuthorizeUrl);
  url.searchParams.append('provider', gitProvider.toLowerCase());
  url.searchParams.append('organizationId', organizationId);
  url.searchParams.append('token', accessToken);
  url.searchParams.append('stage', stage);

  return url.toString();
};

export const isGitProviderUsingToken = (gitProvider: GitProviderTypes) => {
  return gitProvider === 'GitLab' || gitProvider === 'AzureDevOps';
};

export const isGitProviderUsingTokenAndTokenIsMissing = (gitProvider: GitProviderTypes, tokenId?: string) =>
  isGitProviderUsingToken(gitProvider) && !tokenId;
